import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface IConfigDataType {
  invoiceUrl: string;
  nationalCurrency: string;
  nationalCurrencyName: string;
  'lpco.attdoc.allowedExtensions': string;
  'lpco.attdoc.maxSizeMB': number;
  externalPaymentReceiptUrl: string;
}

export interface IConfigReducerState {
  data: Nullable<IConfigDataType>;
  loading: boolean;
}

const initialState: IConfigReducerState = {
  data: null,
  loading: false,
};

export const configs = createSlice({
  name: 'configs',
  initialState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setConfigsData: (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    },
  },
});

export const { setConfigsData, setLoading } = configs.actions;
